import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectShowCreateButton = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.selectedUsers],
  (users) => !!users.length
);
